import * as angular from "angular";

export class QrCodeService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/campaign/qrcode";
    }

    campaignCode(): Promise<object> {
        return this.$http.get(this.v2Root + "/code");
    }

    regenerateCampaignCode(): Promise<object> {
        return this.$http.post(this.v2Root + "/code/regenerate");
    }

    pending(): Promise<object> {
        return this.$http.get(this.v2Root + "/pending");
    }

    approve(id: number): Promise<object> {
        return this.$http.post(this.v2Root + "/pending/" + id + "/approve");
    }

    reject(id: number): Promise<object> {
        return this.$http.post(this.v2Root + "/pending/" + id + "/reject");
    }

    personalCode(): Promise<object> {
        return this.$http.get(this.v2Root + "/personal");
    }

    getSettings(): Promise<object> {
        return this.$http.get(this.v2Root + "/settings");
    }

    saveSettings(data: {
        enabled: boolean;
        team_id: number | null;
        require_manager_approval: boolean;
    }): Promise<object> {
        return this.$http.post(this.v2Root + "/settings", data);
    }
}

angular.module("vcServices").service("QrCodeService", QrCodeService);
